import SDKConfigurationModel from "../../Configurator/Models/SDKConfiguraitonModel";
import PaginationModel from "../../Global/Models/Pagination/PaginationModel";
import ClientHttps from "../../Https/ClientHttps";
import LoyaltyHttps from "../../Https/LoyaltyHttps";
import LoyaltyFacade from "./Facade/LoyaltyFacade";
import LoyaltyFilters from "./Models/Filters/LoyaltyFilters";
import { FeaturesConfigModels } from "../../Global/Types/GlobalTypes";
import RankingsFilters from "./Models/Filters/RankingsFilters";
import ProfileHttps from "../../Https/ProfileHttps";
import HighestSuccessRateModel from "./Models/HighestSuccessRate/HighestSuccessRateModel";
import ContestWinners from "../TopX/Models/Games/Winners/ContestWinners";
import EntitiesFollowsFilters from "./Models/Filters/EntitiesFollowsFilters";
import EntitiesFollows from "./Models/EntitiesFollows/EntitiesFollows";
import TemplateByIdModel from "./Models/Template/TemplateByIdModel";
import HighestSuccessRateFilters from "./Models/Filters/HighestSuccessRateFilters";
import LocalCacheInstanceFactory from "../../Global/Factories/LocalInstanceFactory";
import { LocalCacheInterface } from "../../Global/Interfaces/GlobalInterfaces";
import TemplateFilters from "./Models/Filters/TemplateFilters";
import LeagueLeaderboardFilters from "./Models/Filters/LeagueLeaderboardFilters";
import ClientBadges from "./Models/Badges/ClientBadges";
import GameLeaderboardFilters from "./Models/Filters/GameLeaderboardFilters";

export default class Loyalty {
    private clientHttps: ClientHttps = null;
    private profileHttps: ProfileHttps = null;
    private loyaltyHttps: LoyaltyHttps = null;
    private loyaltyFacade: LoyaltyFacade = null;
    private localCache: LocalCacheInterface = null;

    constructor(config: SDKConfigurationModel) {
        this.clientHttps = new ClientHttps(config);
        this.profileHttps = new ProfileHttps(config);
        this.loyaltyHttps = new LoyaltyHttps(config);
        this.localCache = new LocalCacheInstanceFactory().createLocalCacheInstance(config.idSchema);
        this.loyaltyFacade = new LoyaltyFacade(config, this.clientHttps, this.loyaltyHttps, this.profileHttps, this.localCache);
    }

    /**
     * @deprecated From 1st October the logic will be replaced by getConfigV2
     * getConfigV2 returns LoyaltyConfigModelV2 with enhanced RewardsModelV2 that includes additional badge categories (games, football, classicQuizzes, eitherOr, discussions, potm, poll) and improved badge models with enhanced metadata and entity/game model integration.
     */
    public getConfig = async (): Promise<FeaturesConfigModels> => {
        console.warn('getConfig is deprecated. From 1st October the logic will be replaced by getConfigV2. The V2 version returns enhanced models with additional badge categories and improved metadata.');
        return await this.loyaltyFacade.getConfig();
    };

    public getConfigV2 = async (disableCache?: boolean) => {
        return await this.loyaltyFacade.getConfigV2(disableCache);
    };

    /**
     * @deprecated From 1st October the logic will be replaced by getClientBadgesV2
     * getClientBadgesV2 returns ClientBadgesV2 model which includes additional badge categories: games, football, classicQuizzes, eitherOr, discussions, potm, and poll (compared to the original model that only includes general, predictor, topX, and matchQuiz).
     */
    public getClientBadges = async (): Promise<ClientBadges> => {
        console.warn('getClientBadges is deprecated. From 1st October the logic will be replaced by getClientBadgesV2. The V2 version returns expanded badge categories including games, football, discussions, and voting badges.');
        return await this.loyaltyFacade.getClientBadges();
    };

    public getClientBadgesV2 = async (disableCache?: boolean) => {
        return await this.loyaltyFacade.getClientBadgesV2(disableCache);
    };

    public getTemplates = async (filters?: TemplateFilters, disableCache?: boolean): Promise<PaginationModel> => {
        return await this.loyaltyFacade.getTemplates(filters, disableCache);
    };

    public getTemplateById = async (templateId: string, disableCache? : boolean): Promise<TemplateByIdModel> => {
        return await this.loyaltyFacade.getTemplateById(templateId, disableCache);
    };

    public getLeaderboard = async (templateId: string, filters?: LoyaltyFilters, disableCache?: boolean) => {
        return await this.loyaltyFacade.getLeaderboard(templateId, filters, disableCache);
    };

    public getLeaderboardForGame = async (gameId: string, filters?: GameLeaderboardFilters, disableCache?: boolean) => {
        return await this.loyaltyFacade.getLeaderboardForGame(gameId, filters, disableCache);
    };

    public getLeaderboardForLeague = async (leagueId: string, filters: LeagueLeaderboardFilters) => {
        return await this.loyaltyFacade.getLeaderboardForLeague(leagueId, filters);
    };

    public getOwnRankings = async (filters?: RankingsFilters, disableCache?: boolean) => {
        return await this.loyaltyFacade.getOwnRankings(filters, disableCache);
    };

    public getUserRankings = async (userId: string, filters?: RankingsFilters, disableCache?: boolean) => {
        return await this.loyaltyFacade.getUserRankings(userId, filters, disableCache);
    };

    public getHighestSuccessRate = async (filters?: HighestSuccessRateFilters, disableCache?: boolean): Promise<HighestSuccessRateModel[]> => {
        return await this.loyaltyFacade.getHighestSuccessRate(filters, disableCache);
    };

    public getTemplateWinners = async (templateId: string, disableCache?: boolean): Promise<ContestWinners> => {
        return await this.loyaltyFacade.getTemplateWinners(templateId, disableCache);
    };

    public getEntitiesFollows = async (filters: EntitiesFollowsFilters, disableCache?: boolean): Promise<EntitiesFollows> => {
        return await this.loyaltyFacade.getEntitiesFollows(filters, disableCache);
    };

    public getTemplateMatches = async (templateId: string, groupId?: string, disableCache?: boolean) => {
        return await this.loyaltyFacade.getTemplateMatches(templateId, groupId, disableCache);
    };
}